import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  CreateInvoiceSigningNote,
  CreateInvoiceSigningNoteVariables,
} from 'common/graphql/__generated__/CreateInvoiceSigningNote';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import ADD_NEW_NOTE from 'common/graphql/CreateInvoiceSigningNote.graphql';

type AccountingEntryNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  invoiceId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const AccountingEntryNotesSection: React.FC<
  AccountingEntryNotesSectionProps
> = ({ invoiceId, data, listRefreshRequest, loading }) => {
  return (
    <GenericNotesSection<
      any,
      CreateInvoiceSigningNote,
      CreateInvoiceSigningNoteVariables
    >
      entityId={invoiceId}
      data={data}
      loading={loading}
      mutationDocument={ADD_NEW_NOTE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
